/**
 * Re-mede os itens já montados de um virtualizer (@tanstack/react-virtual).
 *
 * Usar sempre em vez de `virtualizer.measure()`: measure() limpa o cache de
 * medidas e devolve as posições para `estimateSize`. Elementos já montados não
 * reportam de novo (o ref não reexecuta e o ResizeObserver só dispara se a
 * altura mudar), então o item fica preso na estimativa — origem dos
 * espaçamentos irregulares entre agrupamentos.
 *
 * Só varre filhos diretos: itens virtuais aninhados (rows dentro da cidade)
 * também usam `data-index` e pertencem a outro virtualizer.
 */
export function remeasureMountedVirtualItems(host, virtualizer) {
  if (!host || !virtualizer?.measureElement) return 0;
  let measured = 0;
  for (const node of Array.from(host.children || [])) {
    if (typeof node.hasAttribute === 'function' && node.hasAttribute('data-index')) {
      virtualizer.measureElement(node);
      measured += 1;
    }
  }
  return measured;
}

export default remeasureMountedVirtualItems;
